module.exports = __webpack_public_path__ + "files/bdb2ea8e685a2a490f14db0a110b9624.svg";